import { withContext } from '@tools/wr-catalog-base'
import Cart from './Cart'

export default withContext(Cart)
